/*
 * Copyright (C) 2019-2022 Corvalent Corporation - All Rights Reserved
 * This software is licensed program property and is Proprietary and Confidential.
 * Unauthorized copying of this file via any medium is strictly prohibited unless
 * prior written permission has been obtained by Corvalent Corporation.
 * In addition, the look and feel of this software as well as the user interface
 * design is also Copyright ©.
 * Notice: This software is not open source.
 * This software is subject to the Corvalent Software License Agreement.
 * You should have received a copy of this license with the software.
 * If not, please write to: sales@corvalent.com
 * All information contained herein is, and remains, the property of
 * Corvalent Corporation and its suppliers, if any. This software may also
 * be covered by U.S. and Foreign Patents, patents in progress, and are
 * protected by trade secret or copyright law
 */

import styled from 'styled-components';

export const Wrapper = styled.section`
  display: flex;
  align-items: center;

  .progress {
    max-width: 200px;
    min-width: 200px;
    max-height: 16px;
    min-height: 16px;
    background-color: #52626d;

    margin-right: ${({ $showPercentage }) => ($showPercentage ? 20 : 0)}px;

    @media (max-device-width: 450px) {
      max-width: 74px;
      min-width: 74px;
      max-height: 8px;
      min-height: 8px;
    }

    .bg-success {
      background-color: #87c833 !important;
    }

    .bg-warning {
      background-color: #ff8717 !important;
    }

    .bg-danger {
      background-color: #ff2d2e, 100% !important;
    }
  }
`;
